import * as React from "react";

function SvgIcons8DatabaseRestore(props, ref) {
  const style = `.st0{stroke:currentColor;stroke-width:0.19;stroke-miterlimit:10;}`;
  return (
    <svg {...{ ...props, ref }} viewBox="0 0 12 12">
      <style type="text/css">{style}</style>
      <path
        className="st0"
        d="M6,0C4.6,0,3.4,0.2,2.5,0.7C2.1,0.9,1.7,1.1,1.4,1.4C1.1,1.7,1,2,1,2.4v7c0,1.3,2.2,2.4,5,2.4
	c1,0,1.9-0.1,2.6-0.3v-0.5C7.9,11.1,7,11.3,6,11.3c-2.7,0-4.6-1-4.6-1.9V8.2C2.2,9,4,9.6,6,9.6c0.5,0,0.9,0,1.4-0.1l0.2-0.2L7.8,9
	C7.3,9.1,6.7,9.1,6,9.1c-2.7,0-4.6-1-4.6-1.9V5.8c0.3,0.3,0.6,0.5,1.1,0.7C3.4,7,4.6,7.2,6,7.2S8.6,7,9.5,6.5
	c0.4-0.2,0.8-0.4,1.1-0.7v1.1L11,7.5V2.4c0-0.4-0.2-0.7-0.4-1c-0.3-0.3-0.7-0.5-1.1-0.7C8.6,0.2,7.4,0,6,0z M6,0.5
	c1.3,0,2.5,0.2,3.3,0.6c0.4,0.2,0.7,0.4,1,0.6c0.2,0.2,0.3,0.5,0.3,0.7c0,0.2-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.4-1,0.6
	C8.5,4.1,7.3,4.3,6,4.3S3.5,4.1,2.7,3.7C2.3,3.5,2,3.3,1.8,3.1C1.5,2.9,1.4,2.6,1.4,2.4c0-0.2,0.1-0.5,0.3-0.7
	c0.2-0.2,0.5-0.4,1-0.6C3.5,0.7,4.7,0.5,6,0.5z M1.4,3.4C1.7,3.7,2.1,4,2.5,4.1C3.4,4.6,4.6,4.8,6,4.8s2.6-0.2,3.5-0.7
	c0.4-0.2,0.8-0.4,1.1-0.7v1.4c0,0.2-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.4-1,0.6C8.5,6.5,7.3,6.7,6,6.7S3.5,6.5,2.7,6.1
	C2.3,5.9,2,5.7,1.8,5.5C1.5,5.3,1.4,5,1.4,4.8C1.4,4.8,1.4,3.4,1.4,3.4z M10,6.9l-2,2.7h1.2V12h1.7V9.6H12L10,6.9z M10,7.7L11,9.1
	h-0.7v2.4H9.6V9.1H8.9L10,7.7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8DatabaseRestore);
